// src/pages/GameListPage.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // for reading URL query
import GameCard from './components/GameCard';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';

const GameListPage = () => {
  const [games, setGames] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Sidebar state
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Get query params (abc & xyz)
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const abc = queryParams.get('abc');
  const xyz = queryParams.get('xyz');

  // Fetch data from API only if abc & xyz exist
  useEffect(() => {
    const fetchGames = async () => {
      if (!abc || !xyz) {
        setError('Missing abc or xyz parameter in URL');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await fetch(
          `https://api.gamegems.co/web/games/list?abc=${abc}&xyz=${xyz}`
        );

        if (!response.ok) {
          throw new Error('Failed to fetch games');
        }

        const data = await response.json();
        setGames(data?.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGames();
  }, [abc, xyz]);

  const filteredGames = games.filter((game) => {
    const title = game.title || game.name || '';
    return title.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <div className="flex bg-gray-900 min-h-screen">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="flex-1 flex flex-col">
        <Navbar toggleSidebar={toggleSidebar} abc={abc} xyz={xyz} />
        <div className="p-6">
          <h1 className="text-2xl font-bold mb-6 text-white page-title">
            Game List
          </h1>

          <input
            type="text"
            placeholder="Search games..."
            className="w-full p-3 bg-gray-800 text-white rounded-lg mb-6 focus:outline-none focus:ring-2 focus:ring-indigo-400"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          {loading ? (
            <p className="text-center text-gray-400">Loading games...</p>
          ) : error ? (
            <p className="text-center text-red-500">{error}</p>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4 game-list-flex">
              {filteredGames.map((game) => (
                <GameCard key={game.id} game={game} abc={abc} xyz={xyz} />
              ))}
            </div>
          )}

          {!loading && filteredGames.length === 0 && (
            <p className="text-center text-gray-500 mt-6">No games found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameListPage;
